import axios from 'axios';

/***********************
 * PREDEFINED API LIST *
 ***********************/
// 通用
// export const BASE = 'https://imtest.wusong.com';
export const BASE = 'https://im.wusong.com';
export const REGISTER_IM = BASE + '/cquser/register';
export const GET_CUSTOMER_SERVER = BASE + '/cquser/getCutomerServer';
export const SESSION_ALIVE = BASE + '/cquser/session/alive';

async function apiRequest(options) {
    return axios({
        ...options,
    }).then(response => response.data);
}

export default apiRequest;

export async function getRequest(api, data, options) {
    return apiRequest({
        method: 'get',
        url: api,
        params: data,
        ...options,
    });
}

export async function postRequest(api, data, options) {
    return apiRequest({
        method: 'post',
        url: api,
        params: data,
        data,
        ...options,
    });
}
